import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";

import protectedAxios from "../../../common/axios";
import LoginActions from "../../../login/duck/actions";
import {
  API_URL,
  NBYULA_ORDERS_EMAIL,
  NBYULA_ORDERS_EMAIL_TEMPLATES,
} from "../../../common/constants";
import SuspenseFallbackComponent from "../../../common/components/SuspenseFallbackComponent";
import { getAutomatedMessages } from "../../../orders/utils";

export function StartEmailConversation({
  subject,
  recipientEmail,
  children,
  triggeredByChildren = true,
  embed = false,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const isUserAuthenticated = useSelector(
    (state) => state.user.isAuthenticated
  );
  let { url } = useRouteMatch();
  url = window.location.search ? url + window.location.search : url;

  const loggedInUserId = useSelector((state) => state.user?.profile?._id);
  const loggedInUserEmail = useSelector((state) => state.user?.profile?.email);
  const loggedInUserFirstName = useSelector(
    (state) => state.user?.profile?.firstName
  );
  const generateSimpleHash = (text) => {
    let hash = 0;
    if (text.length === 0) return hash;
    for (let i = 0; i < text.length; i++) {
      const char = text.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    return hash;
  };

  useEffect(() => {
    if (!triggeredByChildren) {
      startConversation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggeredByChildren]);

  const startConversation = async () => {
    if (!isUserAuthenticated) {
      return dispatch(
        LoginActions.showLoginModal(true, {
          redirectTo: url,
          isLoginDismissible: true,
        })
      );
    }

    const senderEmail = await protectedAxios.post(
      `${API_URL}/v1/chat/conversation.getOrCreateEmailId`,
      {
        uid: loggedInUserId,
        intent: "profile",
      }
    );

    if (!senderEmail) {
      toast.error("Unable to create Conversation.");
      return;
    }

    if (loggedInUserEmail === recipientEmail) {
      toast.error("You can't start a conversation with yourself.");
      window.location.href = "/500";
    }

    const response = await protectedAxios.post(
      `${API_URL}/v1/chat/conversation.getOrCreateGamePlayer`,
      { email: recipientEmail }
    );

    if (!response) {
      toast.error("Unable to create Conversation.");
      return;
    }

    const recipientGamePlayer = response.data;
    let pathname = "/conversations";
    if (embed) {
      pathname = "/embed/conversations";
    }

    const searchParams = new URLSearchParams(window.location.search);
    const chatWithNbyulaChannel = searchParams?.get("chatWithNbyulaChannel");
    const link = searchParams?.get("link");
    const title = searchParams?.get("title");
    const message = searchParams?.get("message");
    const customMessage = searchParams?.get("customMessage");

    const _payload = {
      owner: loggedInUserId,
      avatar: response.data?.avatar || "",
      name: recipientGamePlayer.firstName,
      isDM: true,
      isGroup: false,
      purpose: {
        key: "EMAIL",
        subject,
        id: generateSimpleHash(
          `${recipientGamePlayer._id}${subject
            ?.split(" ")
            ?.join("")}${loggedInUserId}`
        ),
        participantIds: [recipientGamePlayer._id, loggedInUserId],
      },
      messages:
        recipientEmail === NBYULA_ORDERS_EMAIL
          ? getAutomatedMessages(loggedInUserFirstName, link, title)
          : customMessage
            ? [
                {
                  textMessage: customMessage,
                },
              ]
            : [],
      message,
    };

    if (chatWithNbyulaChannel === "true") {
      _payload["owner"] = recipientGamePlayer._id;
      _payload["purpose"]["openChatWith"] = [loggedInUserId];
    }

    if (recipientEmail === NBYULA_ORDERS_EMAIL) {
      try {
        await protectedAxios.post(
          `${API_URL}/v1/notification/send-email-to-orders-at-nbyula`,
          {
            template: NBYULA_ORDERS_EMAIL_TEMPLATES.ORDER_ACCEPTED,
            title,
            link,
          }
        );
      } catch (error) {
        console.error(error);
      }
    }

    history.push({
      pathname,
      search: window.location.search,
      state: _payload,
    });
  };
  return (
    <>
      {triggeredByChildren ? (
        <Link to="#" onClick={startConversation}>
          {children ? children : "Contact Nbyula Support"}
        </Link>
      ) : (
        <>
          <SuspenseFallbackComponent />
        </>
      )}
    </>
  );
}
